import type { OperationHistoryFilterItem } from '@/shared/types';
import { useDictionary } from './useDictionary';

const useHistoryFiltersDictionary = () => {
  const { data, isLoading, error } = useDictionary<
    OperationHistoryFilterItem[]
  >({
    dictionaryName: 'historyfilters',
  });

  return {
    data,
    isLoading,
    error,
  };
};

export { useHistoryFiltersDictionary };
